<template>
  <div>
    <ProcurePage isType="审核"></ProcurePage>
  </div>
</template>
<script>
import api from '@/apis/api.js';
export default {
  name: 'ProcureExamine',
  data () {
    return {
    }
  },
  components: {
		ProcurePage: resolve => require(["@/components/InvoiceManage/ProcurePage.vue"],resolve),
  },
  watch: {

  },
  filters:{
  },
  methods: {
		
  },
  created() {
  },
  mounted (){
    
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/InvoiceManage/ProcureExamine.vue